module.exports = __webpack_public_path__ + "static/knittedwrap1-530f8a11f3013bfad38aa3c242fe8d0b.jpeg";